import { ConstantsLagoon } from '../common/ConstantsLagoon';
import { useLagoon } from '../hooks/useLagoon';

const toArray = (value: unknown): string[] => {
  if (Array.isArray(value)) return value;
  if (typeof value === 'string')
    return value.split(',').map((item) => item.trim());
  return [];
};

export const getAiBioEligibility = (
  policyNumber: string,
  currentSelectedState?: string
) => {
  // 1. Validate required inputs first
  if (!policyNumber || !currentSelectedState) return false;

  const featureInclusion = useLagoon('feature-inclusion')();
  const aiBioFeatureRow = featureInclusion?.find(
    (row) =>
      row.dntFeature ===
      ConstantsLagoon.FEATURE_INCLUSION_FLAGS.AI_BIO_ELIGIBILITY_STATES
  );

  if (!aiBioFeatureRow) return false;
  const { policyIds, situsState } = aiBioFeatureRow;

  // 2. Convert data to arrays, handling both string and array types
  const policyIdsArray = toArray(policyIds);
  const situsStateArray = toArray(situsState);

  // 3. Check if the configuration arrays are empty
  if (policyIdsArray.length === 0 || situsStateArray.length === 0) {
    return false;
  }

  // 4. Perform the final eligibility check
  return (
    policyIdsArray.includes(policyNumber) &&
    situsStateArray.includes(currentSelectedState)
  );
};
